import React from "react";
import Link from "next/link";
import styles from "./blog_single_hero.module.scss";
import { htmlParse, readingTime } from "@unisearch/helpers";
import PageInfo from "@modules/study/common/page_info";
import GoogleAdTop from "@unisearch/common/google_ad_top";

export const BlogSingleHero = ({ pageData, ...props }) => {
  return (
    <section className={`${styles.section_study_banner} !pt-7`}>
      <div className="container">
        <GoogleAdTop />
        <div className={styles.hero_container}>
          <p className={styles.sub_heading}>
            <span className="bold">{pageData?.categoryName}</span>
            &nbsp; {pageData?.content && readingTime(pageData?.content)} min
            read
          </p>
          <h1 className="heading-one">{pageData?.title}</h1>
          {pageData && pageData?.summary && (
            <div className={styles.summary}>
              {pageData?.summary ? htmlParse(pageData?.summary) : ""}
            </div>
          )}

          <div className={styles.breadcrumbs}>
            <Link legacyBehavior href="/">
              <a>
                <span>Home</span>
              </a>
            </Link>
            {" - "}
            <Link legacyBehavior href="/blog">
              <a>
                <span>Blog</span>
              </a>
            </Link>
            {pageData && pageData?.parimaryCategory && (
              <>
                {" - "}
                <Link
                  legacyBehavior
                  href={`/blog/category/${pageData?.parimaryCategory?.slug}`}
                >
                  <a className={styles.active}>
                    {pageData?.parimaryCategory?.title}
                  </a>
                </Link>
              </>
            )}
          </div>

          <PageInfo
            pageType={"blog"}
            data={pageData}
            id={pageData?.id}
            authorName={pageData?.author?.authorName}
            authorImage={pageData?.author?.profileImageSrc}
          />
        </div>
      </div>
    </section>
  );
};

export default BlogSingleHero;
